/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable */
import clsx from 'clsx'
import React, {FC, useEffect, useRef, useState} from 'react'
import { HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {Link} from 'react-router-dom'
import ChatIcon from '../header/ChatIcon.png'
import ScheduleIcon from '@mui/icons-material/Schedule';
import ClockInModal from './TimeSheets/ClockInModal'
import {RootState} from '../../../../setup'
import {useDispatch, useSelector} from 'react-redux'
import NotificationsIcon from './Notifications/NotificationsIcon'
import HelperIcon from './HelperIcon/HelperIcon'
import TimezoneSelector from '../../../../app/reusable-components/forms/TimeZoneField'
import {setTimeZone} from '../../../../setup/redux/timeZone/reducer'
import axios from 'axios'
import {toast} from 'react-toastify'
import profilepicture from '../../../../assets/profilepicture/profilepicture.jpg'
import { useMediaQuery, useTheme } from '@mui/material' 

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const selectAuth = (state: RootState) => state.auth
const Topbar: FC = () => {
  const {config} = useLayout()
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'))
  const [openClockInModal, setOpenClockInModal] = useState(false)
  const auth = useSelector(selectAuth)
  const profileImgKey = auth.user.profileImg;
  const [profileUrl, setProfileUrl] = useState<string>(profilepicture); 
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null)
  const userTimeZone = auth?.user?.timezone || 'America/New_York';
  const [selectedTimeZone, setSelectedTimeZone] = useState(userTimeZone);

  const fetchPresignedUrl = async (fileKey: string) => {
    try {
      const response = await axios.get(`/batchfile/fetch-file-url`, {
        params: { fileKey },
      });

      if (response.status === 200) {
        setProfileUrl(response.data.presignedUrl); 
      }
    } catch (error) {
      console.error('Error fetching presigned URL:', error);
      setProfileUrl(profilepicture); 
    }
  };
  useEffect(() => {
    if (profileImgKey) {
      if (!profileImgKey.startsWith('http')) {
        fetchPresignedUrl(profileImgKey);
      } else {
        setProfileUrl(profileImgKey);
      }
    }
  }, [profileImgKey]);

  const handleToggleMenu = (event) => {
    event.stopPropagation()
    setMenuOpen(!isMenuOpen)
  }

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (userTimeZone) {
      dispatch(setTimeZone(userTimeZone))
    }
  }, [userTimeZone]);
  
  const handleTimezoneChange = async (timeZone) => {
    try {
      dispatch(setTimeZone(timeZone))
      setSelectedTimeZone(timeZone)
      const data = {
        timezone: timeZone,
        _id: auth?.user?._id,
      }
      const response = await axios.put('/user/timezone', data)
      const {message, status, success} = response?.data
      if (success && status === 200) {
        toast.success(message)
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div className='d-flex align-items-stretch justify-content-between flex-shrink-0'>
      {/* Search */}
      {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}

      {/* Activities */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Drawer toggle */}

      {/* <div
          className={clsx('btn btn-icon btn-active-light-primary btn-custom', toolbarButtonHeightClass)}
          id='kt_activities_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen032.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div> */}

      {/* end::Drawer toggle */}
      {/* </div> */}
      {/* Quick links */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Menu wrapper */}

      {/*         
        <div
          className={clsx('btn btn-icon btn-active-light-primary btn-custom', toolbarButtonHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen025.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div> */}

      {/* <QuickLinks /> */}
      {/* end::Menu wrapper */}
      {/* </div> */}

      {/* CHAT */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Menu wrapper */}

      {/* <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom',
            toolbarButtonHeightClass
          )}
          id='kt_drawer_chat_toggle'
        >
          <KTSVG
            path='/media/icons/duotune/communication/com012.svg'
            className={toolbarButtonIconSizeClass}
          />

          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'></span>
        </div> */}

      {/* end::Menu wrapper */}
      {/* </div> */}

      {/* NOTIFICATIONS */}
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}> */}
      {/* begin::Menu- wrapper */}

      {/* <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen022.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div> */}

      {/* <HeaderNotificationsMenu /> */}
      {/* end::Menu wrapper */}
      {/* </div> */}

      <div className='d-flex align-items-center' style={{width:isMobileView ? 'auto' :  "15vh", marginRight: isMobileView ? "20px" : "10px", }}>
        <TimezoneSelector onTimezoneChange={handleTimezoneChange}/>
      </div>
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        {auth.user.isCaregiver === true ? (
          <div
            onClick={() => setOpenClockInModal(true)}
          >
          <ScheduleIcon
          style={{
                height: isMobileView ? '2rem' : '3rem',
                width: isMobileView ? '2rem' : '3rem',
                marginRight: isMobileView ? '0px' : '10px',
                marginLeft: isMobileView ? '0px' : '10px',
                color: 'grey'
              }}
            />
          </div>
          ) : null}
        <ClockInModal
          title={'Time Tracker'}
          showClockInModal={openClockInModal}
          onCancel={() => setOpenClockInModal(false)}
        ></ClockInModal>
        <NotificationsIcon></NotificationsIcon>
        <HelperIcon></HelperIcon>

        <Link to={`/chat`} className='mx-4 btn btn-icon btn-active-light-primary btn-custom '>
          <img
            src={ChatIcon}
            style={{
              height: isMobileView ? '2rem' : '3rem',
              width: isMobileView ? '2rem' : '3rem',
              marginRight: isMobileView ? '20px' : '10px',
              marginTop: isMobileView ? '4px' : '0px'
            }}
            alt='Chat App Logo'
          />
        </Link>
        <div
          style={{position: 'relative'}}
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          onClick={handleToggleMenu}
        >
         <img
          alt="Profile"
          src={profileUrl}
          style={{
            width: isMobileView ? '33px' : '50px', 
            height: isMobileView ? '33px' : '50px',
            marginLeft: isMobileView ? '-25px' : '10px',
            objectFit: 'cover', 
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', 
            border: '2px solid #fff',
          }}
        />
          {isMenuOpen && (
            <div
              ref={menuRef}
              style={{
                position: 'absolute',
                top: '100%',
                right: '0',
                zIndex: '2000',
                marginTop: '5px',
              }}
            >
              <HeaderUserMenu />
            </div>
          )}
        </div>
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {/* {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Topbar}
